<div class="application-dialog-aligned-accelerators-part">
	<readonly-access [readonly]="accApplDialogDataService.isReadonly()"></readonly-access>
	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
		[rows]="alignedAccelerators()"></grid-content>
</div>